if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.activeIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.content = this.querySelector('.product-media-modal__content');
        this.previousButton = this.querySelector('[data-media-previous]');
        this.nextButton = this.querySelector('[data-media-next]');

        this.previousButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.nextButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.previousButton?.addEventListener('click', () => this.showAdjacentMedia(-1));
        this.nextButton?.addEventListener('click', () => this.showAdjacentMedia(1));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        this.content?.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
        this.content?.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      showActiveMedia() {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        const requestedMediaId = this.openedBy?.getAttribute('data-media-id');
        const requestedIndex = mediaItems.findIndex((item) => item.dataset.mediaId === requestedMediaId);
        this.showMediaAt(requestedIndex >= 0 ? requestedIndex : 0);
      }

      showMediaAt(index) {
        const mediaItems = this.getMediaItems();
        if (!mediaItems.length) return;

        this.activeIndex = (index + mediaItems.length) % mediaItems.length;

        mediaItems.forEach((item, itemIndex) => {
          const isActive = itemIndex === this.activeIndex;
          item.classList.toggle('active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        if (this.content) {
          this.content.scrollTop = 0;
          this.content.scrollLeft = 0;
        }
      }

      showAdjacentMedia(direction) {
        this.showMediaAt(this.activeIndex + direction);
      }

      onKeyDown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showAdjacentMedia(-1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showAdjacentMedia(1);
        }
      }

      onTouchStart(event) {
        if (!window.matchMedia('(max-width: 749px)').matches || event.touches.length !== 1) return;

        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
      }

      onTouchEnd(event) {
        if (!window.matchMedia('(max-width: 749px)').matches || event.changedTouches.length !== 1) return;

        const distanceX = event.changedTouches[0].clientX - this.touchStartX;
        const distanceY = event.changedTouches[0].clientY - this.touchStartY;

        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;

        this.showAdjacentMedia(distanceX > 0 ? -1 : 1);
      }
    }
  );
}
